import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appvalue'
})
export class AppValuePipe implements PipeTransform {
  transform(value: any) {
    return value != undefined ? value : "-";
  }
}